const GameRecordMyComponent = () => import('@/views/query/GameRecord/GameRecordMy/GameRecordMyView')

export default [
    {
        path:'/GameRecordMyIndex',
        name:'GameRecordMyRouter',
        component:GameRecordMyComponent
    }
]